<template>
  <div v-if="loading" class="loading-wrap">
    <div class="spinner" >
      <img src="@/assets/loading.gif" alt="loading" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  computed:{
    loading() {
      return this.$store.getters['view/loading'];
    },
  }
};
</script>

<style scoped>
.loading-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  z-index: 9999;
}
.spinner {
  width: 100%;
  height: 100%;
  background: transparent;
}
.spinner img {
  max-width: 500px;
  width: 10%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
@media (max-width: 800px) {
  .spinner img {
    width: 20%;
  }
}
</style>
